import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { DPTimeSheet } from './model/dp-timesheet';
import { DPTimeSheetService } from './dp-timesheet.service';
import { DPProject } from './model/dp-project';
import { DPProjectService } from './dp-project.service';
import { Router } from '@angular/router';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { ToasterService } from 'angular2-toaster/src/toaster.service';



@Component({
    templateUrl: 'dp-timesheet-create.component.html'
})
export class DPTimeSheetCreateComponent implements OnInit {
    @Input() timesheet: DPTimeSheet;
    @Output() close = new EventEmitter();
    errorResponse: any;
    navigated = true; // true if navigated here
    success: any;
    storedStatus = 'active';
    storedBillable = 0;
    isFirst: any;
    project: DPProject;
    requestedProjectId: number;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    submitting = false;
    statuses = ['active', 'cancelled', 'completed', 'onhold'];
    notes: string;

    constructor(
        private toasterService: ToasterService,

        private router: Router,
        private _service: NotificationsService,
        private timeSheetService: DPTimeSheetService,
        private projectService: DPProjectService,
        private route: ActivatedRoute) {
    }

    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };

    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';
        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;
        this.createNotification();
    }

    createNotification() {
        switch (this.notificationType) {
            case 'success':
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    ngOnInit() {
        this.route.params.forEach((params: Params) => {
            const project_id = params['project_id'];
            this.requestedProjectId = project_id;
            this.navigated = true;
            this.projectService.getProject(this.requestedProjectId)
                .then(project => this.project = project);
        });
        this.timesheet = new DPTimeSheet();
        this.isFirst = true;
    }


    save1(timesheet: DPTimeSheet, isValid: boolean) {
        // call API to save customer
        if (isValid == true) {
            if (+timesheet.hours > 999.99 || +timesheet.hours < 0) {
                this.submitting = false;
                this.notificationType = 'error';
                this.notificationTitle = 'Error';
                this.notificationContent = 'The hours must be below 999.99 and above 0';
                this.createNotification();
            } else {
                timesheet.user_id = +localStorage.getItem('user_id');
                timesheet.hours = timesheet.hours.toString();
                timesheet.notes = this.notes;
                timesheet.billable = this.storedBillable;

                this.submitting = true;
                this.save(timesheet);
            }
        }
    }

    save(timesheet: DPTimeSheet) {
        this.timesheet = timesheet;
        this.timeSheetService
            .createTimeSheet(this.requestedProjectId, this.timesheet)
            .then(timesheet => {
                this.timesheet = timesheet;
                this.submitting = false;
                this.goBack(); // saved hero, w/ id if new
            })
            .catch(error => this.errorHandler(error));

    }
    writeNotes(insertedNotes: string) {
        this.notes = insertedNotes;
    }

    goBack() {
        if (this.navigated) {
            event.stopPropagation();
            this.router.navigate(['/demandportal/customer/account/projects/projectdetail', this.project.project_id]);
        }
    }

    checkBillable() {
        if (this.storedBillable == 0) {
            this.storedBillable = 1;
        }
        else {
            this.storedBillable = 0;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-timesheet-create.component.ts